import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import { colors, heading4, spacing, backgroundColors } from 'ui/theme';
import { Button, BUTTON_SIZES } from 'ui/button';
import { Drawer } from '../drawer';

export const TakeoverWrapper = styled.div<{ $isOverlay?: boolean; $isMainApp?: boolean }>`
  align-items: flex-end;
  position: fixed;
  width: 100%;
  height: 100%;
  right: 0;
  top: 0;
  display: flex;
  flex-direction: column;
  /** NOTE: this should be updated once we have the zIndex constants */
  z-index: ${({ $isMainApp }) => ($isMainApp ? 1001 : 20)};
  /** NOTE: if takeover is open and isOverlay, should show darker bg */
  ${({ $isOverlay }) => $isOverlay && `background-color: ${backgroundColors.backgroundScreen};`}
`;

export const TakeoverDrawer = styled(Drawer)`
  flex: 1 1 auto;
  overflow: auto;
  position: relative;
`;

export const TakeoverFooterButton = styled(Button).attrs((props) => ({
  size: props.size || BUTTON_SIZES.LARGE,
}))`
  margin-left: ${spacing.half};
`;

/* ------------------------------- HEADER BAR ------------------------------- */
/**
 * NOTE: All this will be removed during https://iterable.atlassian.net/browse/WF-615
 */

export const HeaderBarWrapper = styled.div<{ $navBarHeight: number }>`
  flex: 0 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: stretch;

  /** include the added padding with the width so it doesn't push out beyond the page */
  box-sizing: border-box;
  height: ${({ theme, $navBarHeight }) => theme.spacing.utils.pxToRem($navBarHeight)};
  width: 100%;
  padding: 0 0 0 ${spacing.fiveEights};
  background-color: ${colors.purple100};
  color: ${colors.white};
`;

export const ArrowContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-right: ${spacing.fiveEights};
  margin-right: ${spacing.fiveEights};
`;

export const HeaderContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1 1 auto;
  justify-content: space-between;

  > button {
    margin-right: ${pxToRem(10)};
  }
`;

export const HeaderBarTitle = styled.h2`
  ${() => heading4}
  color: ${colors.white};
  margin-bottom: 0;
`;

export const BadgeWrapper = styled.div`
  flex: auto;
  margin-left: ${pxToRem(10)};
`;
